import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type':  'application/json'
    //authorization: 'my-auth-token'
  })
};

@Injectable({
  providedIn: 'root'
})
export class QuestionnaireService {

  constructor(private http: HttpClient) { }
  private _getQuestion = environment.local+'test/getquestion';
  private _saveQuestion = environment.local+'test/savequestion';
  private _getExams = environment.local+'test/getexams';
  private _saveResult = environment.local+'test/saveresult'
  private _createExam = environment.local+'test/createexam'


  getQuestionnaire(userData: any) {
    return this.http.post<any>(this._getQuestion, userData, httpOptions)
  }

  saveQuestionnaire(userData: any) {
    return this.http.post<any>(this._saveQuestion, userData, httpOptions)
  }
  
  getexams(userData: any) {
    return this.http.post<any>(this._getExams, userData, httpOptions)
  }

  saveResult(userData: any) {
    return this.http.post<any>(this._saveResult, userData, httpOptions)
  }

  createExam(userData:any){
    return this.http.post<any>(this._createExam, userData, httpOptions)
  }
}
